export const GET_LOADER_STATUS = "GET_LOADER_STATUS";
export const SET_LOADER_STATUS = "SET_LOADER_STATUS";
